<template>
	<div class="app flex-row align-items-center">
		<div class="container">
			<b-row class="justify-content-md-center">
				<img class="logoag" src="img/brand/logo.png" alt="Logo Aldea Global"/>
			</b-row>
			<b-row class="justify-content-center">
				<b-col md="5">
					<b-card-group>
						<b-card no-body class="p-4">
							<h3 class="text-center">Ingrese su nueva contraseña</h3>
							<b-card-body>
								<b-row>
									<b-input-group class="mb-4">
										<b-input-group-prepend>
											<b-input-group-text>
												<i class="icon-lock"></i>
											</b-input-group-text>
										</b-input-group-prepend>
										<b-form-input
												type="password"
												class="form-control"
												placeholder="Escriba su nueva contraseña"
												autocomplete="current-password"
												@input="setLoginPassword"
												@keyup.enter="login"></b-form-input>
									</b-input-group>
									<b-col cols="12" class="text-center">
										<b-button @click="newPass" variant="primary" class="px-4">
											<i class="fa fa-save"></i> Guardar Cambios
										</b-button>
									</b-col>
								</b-row>
							</b-card-body>
						</b-card>
					</b-card-group>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
	import {mapState, mapMutations, mapActions} from 'vuex';
	import router                               from '../../router';

	export default {
		name    : 'Login',
		data() {
			return {
				showDismissibleAlert: false

			}
		},
		mounted() {
			if (this.token) {
				return router.push('/');
			}
		},
		computed: {
			...mapState('authentication', [
				'loginUser',
				'loginPassword',
				'loginError',
				'token',
			]),
		},
		methods : {
			validate() {
				if (router.currentRoute.query.t)
					axios.post("/api/auth/vreset", {token: router.currentRoute.query.t}).then(({data}) => {
						if ((data.status !== "Ok"))
							router.push("/");
					}).catch(() => {
						return toastr["error"]('Error de verificación');
					});
				else
					router.push("/");
			},
			...mapMutations('authentication', [
				'setLoginUser',
				'setLoginPassword',
			]),
			...mapActions('authentication', [
				'login', 'newPass'
			]),
		},
		beforeMount() {
			this.validate()
		}
	}
</script>
<style scoped>
	.titulito {
		margin-left: 1em;
	}

	@media (max-width: 799px) {
		.logoag {
			margin-left: 22%;
			margin-bottom: 1.5em;
			width: 55%;
		}
	}

	@media (min-width: 800px) {
		.logoag {
			margin: 1.5em;
			width: 30%;
		}
	}
</style>
